import { log } from "missionlog";
import { Moment } from "moment";
import * as React from "react";
import { FunctionComponent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { urlHistoryGetParaHistory, WORDITEMTYPE } from "../../../../api/apilinks";
import { httpGetAuth, HttpResponse } from "../../../../api/httpAPI";
import { paraHistoryOK } from "../../../../api/schema/getParaHistoryResp";
import { limaLogTag } from "../../../../limaCommon/limaLog";
import { LimaHideableSection } from "../../../../limaComponents/LimaHideableSection";
import { LimaHideableSection2 } from "../../../../limaComponents/LimaHideableSection2";
import { LimaLoadingComponnet } from "../../../../limaComponents/LimaLoadingComponnet";
import limaLoadeStore from "../../../../store/limaLoaderStore";
import limaStore from "../../../../store/limaStore";
import { SelectedInWord } from "../../../../types/wordObjects";
import HistParaItemTextRow from "../HistParaItemParaTextRow";
import { useMultiselectSwitch } from "../../../../limaCommon/customHooks/useMultiselectSwitch";
// import { Checkbox } from "@fluentui/react";
// import { useMultiselect } from "../../../../limaCommon/customHooks/useMultiselect";

type HistParaItemParaTextItemsProps = {
  dateFrom: Moment;
  dateTo: Moment;
  selectedItem: SelectedInWord | null;
  showSelect?: boolean;
  initSelectedTimestamp?: string;
  onSelectCallBack?: (selectedTimeastamp: string) => void;
};
//({ logo, message, title }: HistItemProps)
const HistParaItemParaTextItems: FunctionComponent<HistParaItemParaTextItemsProps> = (
  props: HistParaItemParaTextItemsProps
) => {
  const [parHistTexts, setParHistTexts] = useState<paraHistoryOK[]>();
  const { selected, isSelected, onChange } = useMultiselectSwitch(props.initSelectedTimestamp);
  const { t } = useTranslation(["tpshow"]);

  const { isLoading, error, refetch } = useQuery<paraHistoryOK[], Error>(
    [
      "userListCopies",
      {
        itemid: (props.selectedItem && props.selectedItem.id) || null,
        itemtype: (props.selectedItem && props.selectedItem.type) || null,
        userid: limaStore.userId || null,
        datefrom: (props.dateFrom && props.dateFrom.toISOString()) || null,
        dateto: (props.dateTo && props.dateTo.toISOString()) || null,
      },
    ],
    () =>
      getHistoryOfPara(
        (props.selectedItem && props.selectedItem.id) || null,
        (props.selectedItem && props.selectedItem.type) || null,
        // limaStore.userId || null,
        (props.dateFrom && props.dateFrom.toISOString()) || null,
        (props.dateTo && props.dateTo.toISOString()) || null
      ),
    {
      refetchOnWindowFocus: false,
      enabled: false,
      refetchOnMount: false,
      onError: (err) => {
        log.error(limaLogTag.HistParaItemParaTextItems, "useQuery get attachements ", err);
      },
      onSuccess: (data: paraHistoryOK[]) => {
        log.info(limaLogTag.HistParaItemParaTextItems, "useQuery success ", data);
        setParHistTexts(data);
      },
    }
  );

  //------------------
  // Reactions
  //------------------

  useEffect(() => {
    log.info(limaLogTag.HistParaItemParaTextItems, "UEF refatch dateFrom");
    void refetch();
  }, [props.dateTo]);
  useEffect(() => {
    log.info(limaLogTag.HistParaItemParaTextItems, "UEF refatch dateTo");
    void refetch();
  }, [props.dateTo]);
  useEffect(() => {
    log.info(limaLogTag.HistParaItemParaTextItems, "UEF refatch selectedItem");
    void refetch();
  }, [props.selectedItem]);

  useEffect(() => {
    log.info(limaLogTag.HistParaItemParaTextItems, "UEF selected");
    // void refetch();
    if (props.onSelectCallBack !== undefined) props.onSelectCallBack(selected);
  }, [selected]);

  if (isLoading) {
    log.info(limaLogTag.HistParaItemParaTextItems, "searching for history");
    return (
      <LimaHideableSection name={`${t("tpshow:history.historyLbl")} `}>{LimaLoadingComponnet(3)}</LimaHideableSection>
    );
  }
  if (error) {
    return (
      <LimaHideableSection name={`${t("tpshow:history.historyLbl")} `}>
        <div>{t("tpshow:history.errorloadingLbl")}</div>
      </LimaHideableSection>
    );
  }

  // let sectionName = `${t("tpshow:history.historyLbl")} `;
  // if (parHistTexts && parHistTexts.length > 0) sectionName += `[${parHistTexts.length}]`;

  return (
    <LimaHideableSection2
      name={t("tpshow:history.historyLbl")}
      addEnabled={false}
      headerCount={parHistTexts && parHistTexts.length > 0 ? String(parHistTexts.length) : "0"}
      headerDefaultContentOpen={true}
    >
      {/* <LimaHideableSection name={sectionName}> */}
      {parHistTexts &&
        parHistTexts.map((paraHistoryItem, index) => (
          <HistParaItemTextRow
            key={paraHistoryItem.order}
            showChanges={index > 0 ? true : false}
            index={index}
            paraHistoryRow={paraHistoryItem}
            showSelect={props.showSelect}
            // initSelectedTimestamp={props.initSelectedTimestamp}
            //onSelectCallBack={props.onSelectCallBack}
            isSelected={isSelected(paraHistoryItem.ts)}
            onSelectChange={onChange}
          ></HistParaItemTextRow>
        ))}
      {/* </LimaHideableSection> */}
    </LimaHideableSection2>
  );
};
export default HistParaItemParaTextItems;

//----------------------
//   REACT QUERY
//----------------------

// type Params = {
//   queryKey: [string, { itemid: string; itemtype: WORDITEMTYPE; userid: string; datefrom: string; dateto: string }];
// };

async function getHistoryOfPara(
  itemid: string,
  _itemtype: WORDITEMTYPE,
  // userid: string,
  datefrom: string,
  dateto: string
) {
  // const [, { itemid, userid, datefrom, dateto }] = params.queryKey;

  if (itemid === null) {
    log.info(limaLogTag.HistParaItemParaTextItems, "getHistoryOfPara: itemid is null");
    return null;
  }
  if (datefrom === null || dateto === null) {
    log.info(limaLogTag.HistParaItemParaTextItems, "getHistoryOfPara: datefrom is null or dateto is null");
    return null;
  }
  const loaderID = limaLoadeStore.add("Getting history from DB");
  let response: HttpResponse<paraHistoryOK[]>;
  try {
    response = await httpGetAuth<paraHistoryOK[]>(urlHistoryGetParaHistory(itemid, datefrom, dateto), loaderID.ac);

    log.info(limaLogTag.HistParaItemParaTextItems, "getHistoryOfPara: asketo to get something", response);
    if (response.parsedBody !== undefined) {
      log.info(limaLogTag.HistParaItemParaText, "getHistoryOfPara: parsedBody is not null", response.parsedBody);
      //   const userListCopies = response.parsedBody;
      return response.parsedBody;
    } else {
      // throw new Error("...No data...");
      log.error(limaLogTag.HistParaItemParaTextItems, "getHistoryOfPara Error no data");
      return null;
    }
  } catch (response) {
    log.error(limaLogTag.HistParaItemParaTextItems, "getHistoryOfPara Error call get data", response);
    // throw new Error("Problem geting data");
    return null;
  } finally {
    //this.setLoadingData(false);
    limaLoadeStore.remove(loaderID.k);
  }
}
